import request from '@/utils/request';
// 获取 排班组 列表
export const getSchedulingList = (params: any) =>
  request({
    url: 'GroupScheduling/schedulingList',
    method: 'get',
    params
  });
// 添加群组
export function addGroupScheduling(data: any) {
  return request({
    url: 'GroupScheduling/scheduling',
    method: 'POST',
    data
  });
}
// 编辑群组
export function editGroupScheduling(data: any) {
  return request({
    url: 'GroupScheduling/scheduling',
    method: 'PUT',
    data
  });
}
// 删除群组
export function delGroupScheduling(data: any) {
  return request({
    url: 'GroupScheduling/scheduling',
    method: 'DELETE',
    data
  });
}
//  启用
export function startScheduling(data: any) {
  return request({
    url: 'GroupScheduling/schedulingState',
    method: 'PUT',
    data
  });
}
// 添加班次
export function addSchedulingShifts(data: any) {
  return request({
    url: 'GroupScheduling/schedulingShifts',
    method: 'post',
    data
  });
}
// edit班次
export function editSchedulingShifts(data: any) {
  return request({
    url: 'GroupScheduling/schedulingShifts',
    method: 'put',
    data
  });
}
// 删除班次
export function delSchedulingShifts(data: any) {
  return request({
    url: 'GroupScheduling/schedulingShifts',
    method: 'DELETE',
    data
  });
}
// 人员
export function getSchedulingShiftsUser(params: any) {
  return request({
    url: 'GroupScheduling/schedulingShiftsUser',
    method: 'get',
    params
  });
}
// 设置人员
export function schedulingShiftsUser(data: any) {
  return request({
    url: 'GroupScheduling/schedulingShiftsUser',
    method: 'put',
    data
  });
}
